import React, { useEffect, useState, useRef } from "react";
import { ReactComponent as QR } from "../assets/qr.svg";

function useOnScreen(ref) {
  const [isIntersecting, setIntersecting] = useState(false);

  const observer = new IntersectionObserver(([entry]) =>
    setIntersecting(entry.isIntersecting)
  );

  useEffect(() => {
    observer.observe(ref.current);
    return () => {
      observer.disconnect();
    };
  }, []);

  return isIntersecting;
}

function Pricing() {
  const title = useRef();
  const isVisible = useOnScreen(title);
  if (isVisible) title.current.classList.add("animate-sub");

  const feed = useRef();
  const isVisible2 = useOnScreen(feed);
  if (isVisible2) feed.current.classList.add("animate-sub");

  return (
    <>
      <div id="pricing" className="w-full bg-blue min-h-screen pb-10">
        <div className="">
          <h1
            ref={title}
            className="text-white pt-10 pb-10 text-center font-sans md:text-6xl text-[10vw] font-bold"
          >
            Pricing
          </h1>

          <div
            ref={feed}
            className="sm:flex p-4 sm:p-0 justify-evenly pb-5 "
          >
            {/* Premium */}
            <div className="w-full p-3 sm:w-1/2 rounded-3xl bg-white sm:m-3 m-auto sm:max-w-[600px]  mb-5">
              <div className="p-6 text-[5vw] sm:text-2xl">
                <h2 className="text-center text-[7vw] sm:text-4xl text-red">
                  Premium
                </h2>
                <hr className="mt-2 divide-gray opacity-50 h-1"></hr>

                <div className="flex items-center mt-5">
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 25 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="12.5" cy="12.5" r="12.5" fill="#4990F5" />
                  </svg>
                  <div className="pl-[1.5vw]">Feed</div>
                </div>

                <div className="flex items-center mt-4">
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 25 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="12.5" cy="12.5" r="12.5" fill="#4990F5" />
                  </svg>
                  <div className="pl-[1.5vw]">LMS auto-login WebView</div>
                </div>

                <div className="flex items-center mt-4">
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 25 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="12.5" cy="12.5" r="12.5" fill="#4990F5" />
                  </svg>
                  <div className="pl-[1.5vw]">Faculty and Student details</div>
                </div>

                <div className="flex items-center mt-4">
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 25 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="12.5" cy="12.5" r="12.5" fill="#EF3354" />
                  </svg>
                  <div className="pl-[1.5vw]">Notifications</div>
                </div>

                <div className="flex items-center mt-4">
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 25 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="12.5" cy="12.5" r="12.5" fill="#EF3354" />
                  </svg>
                  <div className="pl-[1.5vw]">Calender</div>
                </div>

                <div className="flex items-center mt-4">
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 25 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="12.5" cy="12.5" r="12.5" fill="#000000" />
                  </svg>
                  <div className="pl-[1.5vw]">More coming soon</div>
                </div>
              </div>

              <div className="mt-4 sm:mt-0 text-right font-medium text-xl sm:text-3xl text-red">
                <span className="line-through pr-4 pb-3"> ₹ XXX </span>
                <div className="text-black font-thin sm:text-5xl mt-2 pr-4">
                  ₹ 0
                </div>
              </div>
            </div>

            <div className="w-full p-3 sm:w-1/2 rounded-3xl bg-white h-full sm:m-3 m-auto sm:max-w-[600px]">
              <div className="p-6 text-[4vw] sm:text-xl">
                <h2 className="text-center text-[7vw] sm:text-4xl">
                  Crowdfunding
                </h2>
                <hr className="mt-2 divide-gray opacity-50 h-1"></hr>
              </div>
              <div className="sm:flex flex-wrap items-center text-xl sm:text-2xl">
                <div className="w-full h-full">
                  <QR className="w-[220px] h-[220px] m-auto text-center md:w-[250px] md:h-[250px]" />
                </div>
                <div className="mx-auto text-center text-blue">
                  UPI ID : autojoomer2@airtel
                </div>
                <div className="py-5 mx-auto text-center">
                  There goes a lot into making a product, AutoJoomer can stay free with the support of users like you.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Pricing;
